import { render, staticRenderFns } from "./ModalAllergens.vue?vue&type=template&id=d9387676"
import script from "./ModalAllergens.vue?vue&type=script&lang=js"
export * from "./ModalAllergens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports